module.exports = __webpack_public_path__ + "img/icon-info.7568a837.png";